// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__3qkws","summary":"CartItem_summary__1jRBW","price":"CartItem_price__2jNb3","amount":"CartItem_amount__3jKyi","actions":"CartItem_actions__12iY3"};